var r = {};
export {
  r as __exports
};
//# sourceMappingURL=index.es384.js.map
